import { render, staticRenderFns } from "./tips.vue?vue&type=template&id=43899e85&"
import script from "./tips.vue?vue&type=script&lang=js&"
export * from "./tips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tips.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/base/tip/tips.vue
// module id = 162
// module chunks = 0